import React, { useState, useEffect } from "react"

import PropTypes from "prop-types"
import classNames from "classnames"
import { makeStyles } from "@material-ui/core/styles"

import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import FormHelperText from "@material-ui/core/FormHelperText";

import styles from "assets/jss/material-dashboard-pro-react/components/customDropdownStyle.js"

const useStyles = makeStyles(styles);

function CustomDropdown(props) {

	const { 
		id,
		menuList,
		fullWidth,
		classeNames,
		disabled,
		name,
		handleDropdown,
		error,
		defaultValue,
		readOnly,
		helperText,
		value,
		disableItems
	} = props

	const [_value, setValue] = useState("")

	const classes = useStyles();
	
	const handleChange = (event) => {
		setValue(event.target.value)
		if ((handleDropdown !== null) & (handleDropdown !== undefined)) {
			handleDropdown(event)
		}
	}

	var formControlClasses;
	if (classeNames !== undefined) {
		formControlClasses = classNames(
			classeNames,
			classes.formControl
		);
	} else {
		formControlClasses = classes.formControl;
	}

	useEffect(() => {		
		if (defaultValue !== undefined) {
			setValue(defaultValue)
		}
	}, [defaultValue])	

	var helpTextClasses = classNames({
    [classes.labelRootError]: error    
  });

	return (
		<FormControl variant="outlined" fullWidth={ fullWidth } className={ formControlClasses }>
			<Select
				id={ id }
				value={ _value }
				onChange={ handleChange }
				className={ classes.select }
				disabled={ disabled }
				name={ name }
				error={ error }
				readOnly={ readOnly }
			>
				{
					menuList && menuList.map((menu, index) => (
						<MenuItem 
							value={ menu.value } 
							key={ index } 
							className={ classes.menuItem } 
							disabled={ !!disableItems ? disableItems.includes(menu.value) : false }
						>
							{ menu.text }
						</MenuItem>
					))
				}
			</Select>
			{helperText !== undefined ? (
        <FormHelperText id={id + "-text"} className={helpTextClasses}>
          {helperText}
        </FormHelperText>
      ) : null}
		</FormControl>
	)
}

CustomDropdown.propsTypes = {
	id: PropTypes.string,
	menuList: PropTypes.array,
	fullWidth: PropTypes.bool,
	classes: PropTypes.string,
	readOnly: PropTypes.bool,
	helperText: PropTypes.node,
	disableItems: PropTypes.array
}

export default CustomDropdown
